import { fromJS, Map } from 'immutable'
import { LOCATION_CHANGE } from 'react-router-redux'

import uuid from 'utils/uuid'

import {
  ADD_CLIENT,
  DELETE_CLIENT,

  ADD_DRIVER,
  UPDATE_DRIVER,
  DELETE_DRIVER,

  RESET_STATE
} from './constants'


export const initialState = fromJS({
  drivers: {},
  clients: [],
  drivers_order: []
})


export default function reducer(state = initialState, action) {
  let drivers, clients, drivers_order

  switch(action.type) {
    case ADD_CLIENT:
      clients = state.get('clients')

      // avoid adding this client twice!
      const exists = !! clients.find((c) => c.id === action.client.id)
      if (exists)
        return state

      clients = clients.push(action.client)
      return state.set('clients', clients)
    case DELETE_CLIENT:
      clients = state.get('clients')
      const clientIndex = clients.findIndex((c) => c.id === action.id)

      if (clientIndex >= 0) {
        clients = clients.delete(clientIndex)
        return state.set('clients', clients)
      } else {
        return state
      }

    case UPDATE_DRIVER:
      drivers = state.get('drivers')

      let updated_driver = drivers.get(action.id)
      updated_driver = updated_driver.set(action.field, action.inputValue)

      drivers = drivers.set(action.id, updated_driver)
      return state.set('drivers', drivers)
    case DELETE_DRIVER:
      drivers = state.get('drivers')
      drivers_order = state.get('drivers_order')

      // we must optimize this to avoid iteration over all items on the List
      drivers_order = drivers_order.filter((id) => action.id !== id)
      drivers = drivers.delete(action.id)
      return state.set('drivers', drivers)
                  .set('drivers_order', drivers_order)
    case ADD_DRIVER:
      const driverUUID = uuid()
      drivers = state.get('drivers')
      drivers_order = state.get('drivers_order')
      // this must be Immutable so react-redux updates component after UPDATE_EXTRA_DATA_FIELD
      // react-redux createConnect use shallow equal
      drivers = drivers.set(driverUUID, Map({
        first_name: action.first_name,
        last_name: action.last_name,
        email: action.email
      }))
      // add UUID to keep adding order.
      drivers_order = drivers_order.push(driverUUID)
      return state.set('drivers', drivers)
                  .set('drivers_order', drivers_order)
    case RESET_STATE:
    case LOCATION_CHANGE:
      return initialState
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/components/DriversForm/reducer.js